import React from 'react';
import { Color } from '../../const/Const';
import { ReactComponent as ReportIcon } from '../../svg/reportIcon.svg';

const ReportApprovedDoc = (props) => {
    return (
        <div style={{ height: 160, width: 160, backgroundColor: Color.white, cursor: 'pointer', marginLeft: 16 }} onClick={() => props.onClick(props.data)}>
            <div style={{ height: 90, width: 160, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: Color.white }}>
                <div style={{ position: 'absolute', color: 'gray', fontSize: 18, marginBottom: '10px' }}> {props.data?.number} </div>
                <ReportIcon />
            </div>
            <div style={{ height: 70, width: 160, display: 'flex', justifyContent: 'center', backgroundColor: Color.white }}>
                <div style={{ textAlign: 'center', fontSize: 12, paddingLeft: 8, paddingRight: 8 }}>
                    {props.data?.name?.length > 40 ? (
                        props.data?.name?.substring(0, 40) + "..."
                    ) : (
                        props.data?.name
                    )}
                </div>
            </div>
        </div>
    );
}

export default ReportApprovedDoc;